// src/lib/marketFormat.js
export function normalizeValue(symbol, val) {
  if (val == null || !Number.isFinite(val)) return null;
  if (symbol.startsWith("rbob-") || symbol.startsWith("ho-")) {
    return val / 100; // convert $/100 gal → $/gal
  }
  return val;
}
